import classes from './RadioButtonV2.module.scss';
import classNames from 'classnames';

const RadioButtonV2 = ({
    name,
    id,
    value,
    onChange,
    checked,
    disabled = false,
    className,
    onClick,
    size,
}) => {
    return (
        <label
            onClick={onClick}
            htmlFor={id}
            className={classNames(
                classes.radioLabel,
                className,
                {
                    'pe-none text-muted': disabled,
                },
                size && classes[size]
            )}
        >
            <input
                type="radio"
                name={name}
                id={id}
                value={value}
                onChange={(event) => {
                    if (onChange) onChange(event);
                }}
                checked={checked}
                disabled={disabled}
            />
        </label>
    );
};

export default RadioButtonV2;
